"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react/jsx-runtime"),t=require("styled-components"),s=require("./IconlistItem.js");function i(e){return e&&e.__esModule?e:{default:e}}const a=i(t).default.ul.withConfig({displayName:"List",componentId:"VDS__sc-175ru7a-0"})`
  margin: 0px;
  padding: 0px;
  li:last-of-type {
    margin-bottom: 0;
  }
`;exports.default=({data:t,size:i,surface:r="light",theme:n,spacing:u})=>e.jsx(a,{children:t.map(((t,a)=>e.jsx(s.default,Object.assign({surface:r,size:i,theme:n,spacing:u},t),a)))});
